export const getSavedPresetURL = ({
  baseURL,
  presetId,
}: {
  baseURL?: string;
  presetId: string;
}): string => {
  return `${baseURL || ''}?savedPreset=${presetId}`;
};
